/** Why a cancellation was called off before it reached its end. */
export enum CancellationCancelReason {
  INSURER_REFUSAL = 'INSURER_REFUSAL',
  CUSTOMER_WITHDRAWAL = 'CUSTOMER_WITHDRAWAL',
  INPUT_ERROR = 'INPUT_ERROR',
}

export const getCancellationCancelReasonLabel = (
  reason: CancellationCancelReason
): string => {
  switch (reason) {
    case CancellationCancelReason.INSURER_REFUSAL:
      return $localize`Refus de l'assureur`;
    case CancellationCancelReason.CUSTOMER_WITHDRAWAL:
      return $localize`Rétractation du client`;
    case CancellationCancelReason.INPUT_ERROR:
      return $localize`Erreur de saisie`;
    default:
      return reason;
  }
};
